import React from 'react';
import styled from 'styled-components';
// @ts-ignore
import { CWBLoadingCrest } from "cwb-react";

interface LoadingProps {
  show: boolean;
}

export default function Loading({ show }: LoadingProps) {
  if (show) {
    return (
      <LoadingRender>
        <CWBLoadingCrest customLogoSrc={`${process.env.PUBLIC_URL}/images/icon-twb-logo-grey.svg`} />
      </LoadingRender>
    );
  }

  return null;
}

const LoadingRender = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  left: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.9);
  
  > div {
    padding-top: 0px;
  }
`;